import { Component, inject } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { SkeletonModule } from 'primeng/skeleton';
import { MenuService } from '../../../services/menu.service';
import { PanelModule } from '../../../modules/panel.module';
import { BusinessListComponent } from '../../business/business-list/business-list.component';
import { ConfirmService } from '../../../modules/confirm/confirm.service';
import { Constants } from '../../../model/common.model';

@Component({
  selector: 'brt-menu-option-list',
  standalone: true,
  imports: [PanelModule, SkeletonModule, BusinessListComponent],
  providers: [ConfirmationService],
  templateUrl: './menu-option-list.component.html',
  styleUrl: './menu-option-list.component.scss'
})
export class MenuOptionListComponent {
  private confirm = inject(ConfirmService);

  basePath = this.route.snapshot.data['basePath'] || '/';
  businessId: any;
  menuOptions: any[];
  total: number;
  loading: boolean = true;
  menus: any[];
  criteria: any = {};
  optionTypes = Constants.MenuItemOptionTypes;
  constructor(public router: Router, private route: ActivatedRoute, private menuService: MenuService) {
    route.params.subscribe(async params => {
      this.businessId = params['bid'];
      this.criteria = { BusinessId: this.businessId };
      await this.load();
    });
  }

  async load(event?: any) {
    this.loading = true;
    this.criteria = {
      BusinessId: this.businessId,
      Query: this.criteria.Query?.trim() || null,
      Type: this.criteria.Type || null,
      Name: this.criteria.Name?.trim() || null,
      Price: this.criteria.Price !== null && this.criteria.Price !== undefined && this.criteria.Price !== '' ? this.criteria.Price : null,
      From: event?.first || 0,
      Size: event?.rows || this.criteria.Size || 50
    };
    var result = await this.menuService.searchMenuOption(this.criteria);
    this.menuOptions = result.List;
    this.total = result.Total;
    this.loading = false;
  }

  loadFromFirstPage() {
    this.load({ first: 0, rows: this.criteria.Size || 50 });
  }

  private async saveMenuOption(menuOption: any) {
    menuOption._loading = true;
    setTimeout(async () => {
      await this.menuService.saveMenuOption(menuOption);
      menuOption._loading = false;
    });
  }

  async deleteMenuOption(menuOption: any) {
    if(!this.confirm.confirm('Are you sure you want to delete this menu option?')) return;
    if (menuOption._loading) return;
    menuOption._loading = true;
    try {
      await this.menuService.deleteMenuOption(menuOption.Id);
      this.menuOptions = this.menuOptions.filter(_ => _.Id !== menuOption.Id);
    } catch (error) {
      console.error('Error deleting menu option:', error);
    } finally {
      menuOption._loading = false;
    }
  }
}
